import { useMemo } from "react";
import useResources from "./use-resources";
import useProfileFilter from "./use-profile-filter";

const ROOT_PATH = "mandat-prelevement";

export default function useMandatPrelevement() {
  const {
    resources: allMandatPrelevements,
    error,
    isLoading,
    create,
    update,
    del,
  } = useResources(ROOT_PATH);
  const { matchesProfileFilter, isFilterActive } = useProfileFilter();

  const mandatPrelevements = useMemo(() => {
    if (!isFilterActive) return allMandatPrelevements;
    return allMandatPrelevements.filter((mandat) =>
      matchesProfileFilter(mandat.id_profile_bailleur),
    );
  }, [allMandatPrelevements, isFilterActive, matchesProfileFilter]);

  return {
    mandatPrelevements,
    error,
    isLoading,
    createMandatPrelevement: create,
    updateMandatPrelevement: update,
    deleteMandatPrelevement: del,
  };
}
